import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ITServices.css';

const BlogDetails = () => {
  return (
    <div className="itservices-page">
      <div className="section-container">
        <button className="back-button" onClick={() => window.history.back()}>
          {'\u2190'} Back
        </button>
      </div>

      <section className="itservices-hero">
        <div className="itservices-hero-content">
          <div className="itservices-hero-text">
            <h1>Future of AI in Business</h1>
            <p>Jan 12, 2026 | Admin</p>
            <div className="itservices-hero-ctas">
              <Link to="/blog" className="cta-primary">Back to Blogs</Link>
              <Link to="/contact" className="cta-secondary">Write for Us</Link>
            </div>
          </div>
          <div className="itservices-hero-visual">
            <div className="hero-box hero-box-1"></div>
            <div className="hero-box hero-box-2"></div>
            <div className="hero-box hero-box-3"></div>
          </div>
        </div>
      </section>

      <section className="itservices-services-overview">
        <div className="section-container">
          <h2>Article Overview</h2>
          <p className="section-subtitle">How AI is shaping decisions, workflows, and growth</p>
          <div className="project-card">
            <p>
              AI is changing how organizations prioritize customer experience, automate
              repetitive work, and make better decisions from data.
            </p>
            <p>
              Teams that start with focused use cases, clean data, and clear success
              metrics typically see the highest return on implementation.
            </p>
            <p>
              The next wave is not just about models. It is about integrating AI into
              real business processes with accountability and measurable outcomes.
            </p>
            <Link to="/blog">Explore more blog posts -&gt;</Link>
          </div>
        </div>
      </section>

      <a
        href="https://wa.me/8630611232?text=Hi%20AILYT%2C%20I%20would%20like%20to%20get%20in%20touch%20with%20you."
        target="_blank"
        rel="noopener noreferrer"
        className="hero-whatsapp-btn"
        title="Chat with us on WhatsApp"
      >
        {'\u{1F4AC}'}
      </a>
    </div>
  );
};

export default BlogDetails;
